import { Plus } from '@phosphor-icons/react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

/** Create Service — aligned to the right of Settings tabs on the list view. */
export function SettingsServicesRatesToolbar() {
  const navigate = useNavigate();

  return (
    <Button
      type="primary"
      icon={<Plus size={16} />}
      onClick={() => navigate('/app/settings/services-rates/create')}
    >
      Create Service
    </Button>
  );
}
